export const CommunityMainServiceType = Object.freeze({
  Plugin: 1, // 表示對應 EIP 功能開關
  Fixed: 2 // 表示固定功能
})
export const communityMainServiceMap = new Map([
  [
    -1,
    {
      rawZhName: '訪客離開',
      i18nKey: 'VisitorCheckOut',
      iconName: 'icon-identification-exit',
      project: 'both',
      url: null,
      badge: ''
    }
  ],
  [
    1,
    {
      rawZhName: '流水號歸戶',
      i18nKey: 'RepeatSerialNumber',
      iconName: null,
      project: null,
      url: null,
      badge: ''
    }
  ],
  [
    2,
    {
      rawZhName: '管理費',
      i18nKey: 'ManagementFee',
      iconName: 'icon-house-money',
      project: 'mgmt',
      url: 'management_control',
      badge: ''
    }
  ],
  [
    4,
    {
      rawZhName: '差勤管理Web打卡',
      i18nKey: 'AttendanceManagementWeb',
      iconName: null,
      project: null,
      url: '',
      badge: ''
    }
  ],
  [
    7,
    {
      rawZhName: '現金代管',
      i18nKey: 'CashCustody',
      iconName: 'icon-cashManagement',
      project: 'housekeeper',
      url: 'cashManagement.aspx',
      badge: ''
    }
  ],
  [
    9,
    {
      rawZhName: '巡邏管理',
      i18nKey: 'PatrolManagement',
      iconName: 'icon-patrol',
      project: 'housekeeper',
      url: 'patrolAdministrate.aspx',
      badge: ''
    }
  ],
  [
    10,
    {
      rawZhName: '社區投票',
      i18nKey: 'CommunityVoting',
      iconName: 'icon-vote',
      project: 'housekeeper',
      url: 'vote.aspx',
      badge: ''
    }
  ],
  [
    11,
    {
      rawZhName: '資產管理',
      i18nKey: 'AssetManagement',
      iconName: 'icon-assets-manage',
      project: 'housekeeper',
      url: 'assetMain.aspx',
      badge: ''
    }
  ],
  [
    14,
    {
      rawZhName: '虛擬戶別',
      i18nKey: 'VirtualHousehold',
      iconName: null,
      project: null,
      url: null,
      badge: ''
    }
  ],
  [
    17,
    {
      rawZhName: '訪客管理',
      i18nKey: 'VisitorManagement',
      iconName: 'icon-identification',
      project: 'mgmt',
      url: 'PlusGuestReservation/List',
      badge: ''
    }
  ],
  [
    21,
    {
      rawZhName: '電子看板',
      i18nKey: 'Billboard',
      iconName: 'icon-ann',
      project: 'mgmt',
      url: 'bulletin',
      badge: ''
    }
  ],
  [
    23,
    {
      rawZhName: '區權會',
      i18nKey: 'UnitOwnerAssembly',
      iconName: 'icon-unit-owner-assembly',
      project: 'mgmt',
      url: 'UnitOwnerAssembly',
      badge: ''
    }
  ],
  [
    24,
    {
      rawZhName: '告警管理',
      i18nKey: 'BAAlert',
      iconName: 'icon-ba-alert',
      project: 'mgmt',
      url: 'BA-alert',
      badge: ''
    }
  ],
  [
    25,
    {
      rawZhName: '新資產',
      i18nKey: 'NewAsset',
      iconName: null,
      project: null,
      url: null,
      badge: ''
    }
  ],
  [
    26,
    {
      rawZhName: '點餐',
      i18nKey: 'OrderingFood',
      iconName: 'icon-order',
      project: 'mgmt',
      url: 'point/orderFood',
      badge: ''
    }
  ],
  [
    30,
    {
      rawZhName: '社區充電',
      i18nKey: 'EVCharging',
      iconName: 'icon-ev-charging',
      project: 'mgmt',
      url: 'EvCharging',
      badge: ''
    }
  ],
  [
    32,
    {
      rawZhName: '智慧櫃',
      i18nKey: 'SmartLocker',
      iconName: 'icon-smart-locker',
      project: 'mgmt',
      url: 'smartLocker',
      badge: ''
    }
  ],
  [
    33,
    {
      rawZhName: '意見反映',
      i18nKey: 'Feedback',
      iconName: 'icon-feedback',
      project: 'mgmt',
      url: 'message',
      badge: ''
    }
  ],
  [
    46,
    {
      rawZhName: '社區公告',
      i18nKey: 'Announcement',
      iconName: 'icon-ann',
      project: 'mgmt',
      url: 'news',
      badge: ''
    }
  ],
  [
    47,
    {
      rawZhName: '推播通知',
      i18nKey: 'PushNotification',
      iconName: 'icon-push',
      project: 'housekeeper',
      url: 'communityPushNotification_v2.aspx',
      badge: ''
    }
  ],
  [
    48,
    {
      rawZhName: '寄放物品',
      i18nKey: 'CollectionPayment',
      iconName: 'icon-collectionP',
      project: 'housekeeper',
      url: 'collectionPayment_v2.aspx',
      badge: ''
    }
  ],
  [
    49,
    {
      rawZhName: '郵務管理',
      i18nKey: 'Postal',
      iconName: 'icon-package',
      project: 'housekeeper',
      url: 'postal.aspx',
      badge: ''
    }
  ],
  [
    50,
    {
      rawZhName: '訪客登記',
      i18nKey: 'VisitorCheckIn',
      iconName: 'icon-identification',
      project: 'housekeeper',
      url: 'CommunityGuestControl.aspx',
      badge: ''
    }
  ],
  [
    51,
    {
      rawZhName: '公設預約',
      i18nKey: 'FacilityReservation',
      iconName: 'icon-reservation',
      project: 'housekeeper',
      url: 'reservation_v2.aspx',
      badge: ''
    }
  ],
  [
    52,
    {
      rawZhName: '規約辦法',
      i18nKey: 'Regulations',
      iconName: 'icon-rules',
      project: 'mgmt',
      url: 'rules',
      badge: ''
    }
  ],
  [
    53,
    {
      rawZhName: '社區行事曆',
      i18nKey: 'Calendar',
      iconName: 'icon-calendar',
      project: 'mgmt',
      url: 'Calendar',
      badge: ''
    }
  ],
  [
    54,
    {
      rawZhName: '瓦斯抄表',
      i18nKey: 'Gas',
      iconName: 'icon-gas-meter',
      project: 'mgmt',
      url: 'communityGas',
      badge: ''
    }
  ],
  [
    55,
    {
      rawZhName: '周邊店家',
      i18nKey: 'NearbyStores',
      iconName: 'icon-store',
      project: 'housekeeper',
      url: 'serviceStores_v2.aspx',
      badge: ''
    }
  ],
  [
    56,
    {
      rawZhName: '智慧建築首頁',
      i18nKey: 'SmartBuilding',
      iconName: 'icon-smart-building',
      project: 'mgmt',
      url: 'bahome',
      badge: ''
    }
  ],
  [
    57,
    {
      rawZhName: '社區對講機',
      i18nKey: 'Intercom',
      iconName: 'icon-intercom',
      project: 'mgmt',
      url: 'intercom/callRecordList',
      badge: ''
    }
  ],
  [
    60,
    {
      rawZhName: '緊急通話',
      i18nKey: 'IntercomEmergency',
      iconName: null,
      project: null,
      url: null,
      badge: ''
    }
  ],
  [
    58,
    {
      rawZhName: '點數管理',
      i18nKey: 'PointManagement',
      iconName: 'icon-coin-pu',
      project: 'housekeeper',
      url: 'pointManage.aspx',
      badge: ''
    }
  ],
  [
    61,
    {
      rawZhName: '「一般點數」補足「現金點數」',
      i18nKey: 'GeneralPointToCashPoint',
      iconName: null,
      project: null,
      url: null,
      badge: ''
    }
  ],
  [
    62,
    {
      rawZhName: '「現金點數」補足「一般點數」',
      i18nKey: 'CashPointToGeneralPoint',
      iconName: null,
      project: null,
      url: null,
      badge: ''
    }
  ],
  [
    63,
    {
      rawZhName: '僅櫃檯點餐',
      i18nKey: 'OnlyCounterOrdering',
      iconName: null,
      project: null,
      url: null,
      badge: ''
    }
  ],
  [
    64,
    {
      rawZhName: '櫃檯點餐+APP點餐+通知取餐',
      i18nKey: 'CounterOrderingAppPickup',
      iconName: null,
      project: null,
      url: null,
      badge: ''
    }
  ],
  [
    66,
    {
      rawZhName: '財務管理',
      i18nKey: 'FinancialManagement',
      iconName: 'icon-financial-management',
      project: 'serverless',
      url: 'financial',
      badge: ''
    }
  ]
])

export const communityMainFixedServiceMap = new Map([
  [
    1,
    {
      rawZhName: '住戶開通',
      i18nKey: 'BindingHousehold',
      iconName: 'icon-open-service',
      project: 'both',
      url: null,
      badge: ''
    }
  ],
  [
    4,
    {
      rawZhName: '社區代訂',
      i18nKey: 'PropertyPromotion',
      iconName: 'icon-property-zone',
      project: 'mgmt',
      url: 'Property',
      badge: 'New'
    }
  ]
])
